const TOKEN_KEY = 'auth_token';

export const setAuthToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const clearAuthToken = () => localStorage.removeItem(TOKEN_KEY);
